export default function numberToMoney(amount: number): String {
  let pounds : number = Math.floor(amount / 100);
  let pence  : number =            amount % 100 ;


  return `${pounds}.${pence.toString().padStart(2, "0")}`;
}
